<ng-template #content let-modal>
    <div class="modal-header background-secondary">
      <h4 class="modal-title" id="modal-basic-title">Editar {{product.name}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form">
            <div class="row m-4">
                <div class="col-4">
                    <label class="form-label">Nombre</label>
                    <input type="text"
                        class="form-control"
                        formControlName="name"
                        
                        placeholder="Ingrese un nombre..."
                        [class.is-invalid]="invalidName"
                        >
                    <small *ngIf="invalidName" class="text-danger">Escoja un nombre de entre 1 y 50 caracteres</small>
                </div>
                <div class="col-8">
                    <label class="form-label">Descripcion</label>
                    <input 
                        class="form-control" 
                        type="text"
                        
                        formControlName="description" 
                        placeholder="Ingrese una descripcion"
                        [class.is-invalid]="invalidDescription"
                        >
                    <small *ngIf="invalidDescription" class="text-danger">Escoja una descripcion de entre 1 y 100 caracteres</small>
                </div>
            </div>
            <div class="row m-4">
            <div class="col-4">
                <label class="form-label">URL de imagen</label>
                <input 
                    type="text" 
                    class="form-control" 
                    formControlName="imgUrl" 
                    
                    placeholder="https://...."
                    [class.is-invalid]="invalidImgUrl"
                    >
                <small *ngIf="invalidImgUrl" class="text-danger">Ingrese una url o suba una imagen</small>
                <input class="form-input" type="file" (change)="upload($event)" accept="image/*">
            </div>
            <div class="col-4">
                <label class="form-label">Precio</label>
                <input 
                    type="number"
                    class="form-control" 
                    formControlName="price" 
                    
                    placeholder="Ingrese un precio..."
                    [class.is-invalid]="invalidPrice"
                    >
                </div>
                <div class="col-4">
                <label class="form-label">Descuento</label>
                <input 
                    type="number" 
                    class="form-control" 
                    formControlName="discount" 
                    placeholder="Ingrese un descuento"
                    [class.is-invalid]="invalidDiscount"
                    
                    >
                </div>
        </div>
        <div class="row m-4">
            <div *ngFor="let t of talles" class="form-check col">
                <input class="form-check-input" type="checkbox"  [formControlName]="t">
                <label class="form-check-label" [for]="t">
                    {{ t }}
                </label>
            </div>
                <small class="text-danger" *ngIf="invalidTalles">Elija al menos un talle</small>
        </div>
        <div class="row m-4">
            <div class="col">
                <select class="form-select" formControlName="category" [class.is-invalid]="invalidCategory"  >
                    <option>Elige categoría</option>
                    <option *ngFor="let cat of categories" [ngValue]="cat?.name">{{cat.name}}</option>
                    </select>
            </div>
            <div class="form-check col-3">
                <input class="form-check-input" type="checkbox" value="" formControlName="isTrending">
                <label class="form-check-label">
                    Es destacado
                </label>
            </div>
            <div class="form-check col-3">
                <input class="form-check-input" type="checkbox" value="" formControlName="isVisible">
                <label class="form-check-label">
                    Esta visible
                </label>
            </div>
        </div>
        </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn bg-orange" (click)="putForm()">Finalizar</button>
    </div>
  </ng-template>
  
  <button class="btn " (click)="open(content)">
    <span class="text-info">Editar</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill text-info" viewBox="0 0 16 16">
      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
    </svg>
  </button>